import { render, staticRenderFns } from "./home.component.vue?vue&type=template&id=76a1bf4a&"
import script from "./home.component.vue?vue&type=script&lang=ts&"
export * from "./home.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "home.component.vue"
export default component.exports